<template>
  <div>
    <loader v-if="!pageLoaded"></loader>

    <div v-else class="px-4 mt-2 mb-8">
      <v-row>
        <v-col cols='12' md='8'>
          <v-card>
            <v-form
              @submit.prevent="save()"
              ref="form"
              lazy-validation
            >
              <v-card-text>
                <v-row>
                  <div class="dropzone-hero-img ma-6"
                    @dragover.prevent
                    @drop.prevent="onFileChange('heroImg', $event)"
                    @click="$refs.heroImageFile.click()"
                  >
                    <img v-if="heroImg" :src="isNotHeroImg() ? heroImg : `${this.baseURL}/img/laureates/350/${heroImg}`"/>
                    <div v-else class="text-center">
                      <div class="text-subtitle-1 mx-2">Drop file here or click to upload image</div>
                      <div class="caption font-weight-medium">Maximum upload file size: 5MB</div>
                    </div>

                    <v-btn
                      v-if="heroImg"
                      @click.stop="removeHeroImage()"
                      small
                      icon
                      class="remove-image-btn"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>

                    <input type="file" ref="heroImageFile" style="display: none" @change="onFileChange('heroImg', $event)">
                  </div>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      v-model="laureate.source"
                      label="Source"
                      class="mx-2"
                      filled
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="laureate.first_name"
                      label="First Name"
                      class="mx-2"
                      filled
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="laureate.last_name"
                      label="Last Name / Organization Name"
                      class="mx-2"
                      filled
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="laureate.nickname"
                      label="Nickname"
                      class="mx-2"
                      filled
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-checkbox
                      v-model="laureate.publish_new"
                      label="Publish"
                      class="mx-2"
                    ></v-checkbox>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-select
                      v-model="laureate.gender"
                      :items="genders"
                      label="Gender"
                      class="mx-2"
                      filled
                    ></v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-select
                      v-model="laureate.type"
                      :items="types"
                      label="Type of Laureate"
                      class="mx-2"
                      filled
                    ></v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                  >
                    <v-textarea
                      v-model="laureate.biography"
                      label="Biography"
                      class="mx-2"
                      rows="6"
                      filled
                      required
                    ></v-textarea>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <div class="blue-grey--text text--darken-3 subtitle-1 mt-n4 mx-2">Date of Birth</div>

                    <div class="d-flex justify-start mt-2">
                      <v-select
                        v-model="dtOfBirth.day"
                        :items="days"
                        label="Day"
                        class="mx-2"
                        dense
                        outlined
                      ></v-select>
                      <v-select
                        v-model="dtOfBirth.month"
                        :items="months"
                        item-text="name"
                        item-value="id"
                        label="Month"
                        class="mx-2"
                        dense
                        outlined
                      ></v-select>
                      <v-select
                        v-model="dtOfBirth.year"
                        :items="years"
                        label="Year"
                        class="mx-2"
                        dense
                        outlined
                      ></v-select>
                      <v-btn
                        v-show="showResetDateOfBirth"
                        @click.prevent="resetDateOfBirth()"
                        small
                        icon
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </div>

<!--                     <div v-if="!isBirthDateValid" class="v-text-field__details mt-4 mx-2">
                      <div class="v-messages theme--light error--text" role="alert">
                        <div class="v-messages__wrapper">
                          <div class="v-messages__message">Please enter a valid date.</div>
                        </div>
                      </div>
                    </div> -->
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <div class="blue-grey--text text--darken-3 subtitle-1 mt-n4 mx-2">Date of Death</div>

                    <div class="d-flex justify-start mt-2">
                      <v-select
                        v-model="dtOfDeath.day"
                        :items="days"
                        label="Day"
                        class="mx-2"
                        dense
                        outlined
                      ></v-select>
                      <v-select
                        v-model="dtOfDeath.month"
                        :items="months"
                        item-text="name"
                        item-value="id"
                        label="Month"
                        class="mx-2"
                        dense
                        outlined
                      ></v-select>
                      <v-select
                        v-model="dtOfDeath.year"
                        :items="years"
                        label="Year"
                        class="mx-2"
                        dense
                        outlined
                      ></v-select>
                      <v-btn
                        v-show="showResetDateOfDeath"
                        @click.prevent="resetDateOfDeath()"
                        small
                        icon
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-select
                      v-model="laureate.professions"
                      :items="professions"
                      item-text="name"
                      item-value="id"
                      label="Profession(s)"
                      class="mx-2"
                      filled
                      multiple
                      small-chips
                    ></v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-select
                      v-model="laureate.nationalities"
                      :items="countries"
                      item-text="nationality"
                      item-value="id"
                      label="Nationality"
                      class="mx-2"
                      filled
                      multiple
                      small-chips
                    ></v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-select
                      v-model="laureate.countries"
                      :items="countries"
                      item-text="name"
                      item-value="id"
                      label="Country of Work"
                      class="mx-2"
                      filled
                      multiple
                      small-chips
                    ></v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-select
                      v-model="laureate.top100_new"
                      :items="top100"
                      label="Top 100"
                      class="mx-2"
                      filled
                    ></v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                  >
                    <v-textarea
                      v-model="laureate.notes"
                      label="Notes"
                      class="mx-2"
                      rows="6"
                      filled
                      required
                    ></v-textarea>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                    class="links"
                  >
                    <v-text-field
                      v-for="(item, $index) in links"
                      :key="$index"
                      v-model="links[$index]"
                      label="Relevant Web Link"
                      :append-outer-icon="$index ? 'mdi-minus' : 'mdi-plus'"
                      @click:append-outer="addRemoveLink($index)"
                      class="mx-2"
                      filled
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <v-btn
                  color="red lighten-5 red--text text--darken-2"
                  depressed
                  class="mx-4 mb-6"
                  @click="callConfirmDeleteLaureateDialog()"
                >
                  Delete
                </v-btn>
                <v-spacer/>
                <v-btn
                  color="accent"
                  depressed
                  class="mx-4 mb-6"
                  type="submit"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-col>

        <v-col cols='12' md='4'>
          <v-card>
            <v-card-text>
              <v-list>
                <div class="text-h6 primary-title primary--text mb-2">Awards</div>
                <template v-for="item in sortedLaureateAwards">
                  <v-hover
                    v-slot:default="{ hover }"
                    :key="item.id"
                  >
                    <v-list-item
                      two-line
                      link
                      exact
                      :to="{ name: 'awards.edit', params: { id: item.id } }"
                    >
                      <v-list-item-action class="list-avatar d-flex justify-center">
                        <img
                          v-if="item.image"
                          :src="`${baseURL}/img/awards/64/${item.image}`"
                        >
                        <v-avatar v-else color="blue-grey lighten-5">
                          <span class="blue-grey--text text--darken-1">
                            {{ item.name | capitalizeName }}
                          </span>
                        </v-avatar>
                      </v-list-item-action>

                      <v-list-item-content>
                        <v-list-item-title>{{ item.name }}</v-list-item-title>
                        <v-list-item-subtitle>{{ item.pivot.year }}</v-list-item-subtitle>
                      </v-list-item-content>

                      <v-list-item-icon>
                        <v-btn
                          v-show="hover"
                          @click.prevent="callConfirmUnlinkAwardDialog(item)"
                          small
                          icon
                          class="remove-image-btn"
                        >
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-list-item-icon>
                    </v-list-item>
                  </v-hover>
                </template>
              </v-list>
              <v-btn
                @click="linkAwardDialog = true"
                absolute
                small
                dark
                fab
                bottom
                right
                color="primary"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Link Award Dialog-->
      <link-award-dialog
        :dialog="linkAwardDialog"
        :awards="awards"
        :years="years"
        @close="closeLinkAwardDialog"
        @link="linkAward"
        ref="linkAwardDialog"
      ></link-award-dialog>

      <!-- Unlink Award Dialog-->
      <confirm-unlink-award-dialog
        ref="confirmUnlinkAwardDialog"
        :award="awardToUnlink"
      ></confirm-unlink-award-dialog>

      <!-- Confirm Delete Laureate Dialog-->
      <confirm-delete-laureate-dialog
        ref="confirmDeleteLaureateDialog"
        :laureate="laureate"
      ></confirm-delete-laureate-dialog>
    </div>
  </div>
</template>

<script>
import ConfirmDeleteLaureateDialog from '@/components/laureates/ConfirmDeleteLaureateDialog.vue'
import ConfirmUnlinkAwardDialog from '@/components/laureates/ConfirmUnlinkAwardDialog.vue'
import LinkAwardDialog from '@/components/laureates/LinkAwardDialog.vue'
import Loader from '@/components/Loader'
import messagesMixin from '@/mixins/messagesMixin'

export default {
  name: 'Edit',

  mixins: [messagesMixin],

  components: {
    ConfirmDeleteLaureateDialog,
    ConfirmUnlinkAwardDialog,
    LinkAwardDialog,
    Loader
  },

  data () {
    return {
      awards: [],
      awardToUnlink: {},
      countries: [],
      currentYear: new Date().getFullYear().toString(),
      dtOfBirth: {
        day: '',
        month: '',
        year: ''
      },
      dtOfDeath: {
        day: '',
        month: '',
        year: ''
      },
      defaultDateOfBirth: null,
      defaultDateOfDeath: null,
      genders: ['Unknown', 'Male', 'Female', 'Intersex', 'Organization'],
      heroImg: '',
      laureate: {
        id: '',
        first_name: '',
        last_name: '',
        awards: [],
        countries: [],
        biography: '',
        date_of_birth: '',
        date_of_death: '',
        gender: '',
        image: '',
        links: '',
        nationalities: [],
        notes: '',
        professions: [],
        publish: '',
        sortedAwards: [],
        sortedCountries: [],
        sortedProfessions: [],
        source: '',
        top100: false,
        top100_new: '',
        type: '',
        user_id: ''
      },
      linkAwardDialog: false,
      links: [''],
      months: [
        {
          id: 1,
          name: 'January'
        },
        {
          id: 2,
          name: 'February'
        },
        {
          id: 3,
          name: 'March'
        },
        {
          id: 4,
          name: 'April'
        },
        {
          id: 5,
          name: 'May'
        },
        {
          id: 6,
          name: 'June'
        },
        {
          id: 7,
          name: 'July'
        },
        {
          id: 8,
          name: 'August'
        },
        {
          id: 9,
          name: 'September'
        },
        {
          id: 10,
          name: 'October'
        },
        {
          id: 11,
          name: 'November'
        },
        {
          id: 12,
          name: 'December'
        }
      ],
      pageLoaded: false,
      professions: [],
      top100: ['Yes', 'No', 'Maybe'],
      types: ['Person', 'Organization']
    }
  },

  mounted () {
    Promise.all([
      this.getAwards(),
      this.getCountries(),
      this.getLaureate(),
      this.getProfessions()
    ])
      .then(() => {
        this.pageLoaded = true
      })
  },

  computed: {
    dateOfBirth () {
      if (this.dtOfBirth.day && this.dtOfBirth.month && this.dtOfBirth.year) {
        const dt = this.dtOfBirth.year + '-' + this.dtOfBirth.month + '-' + this.dtOfBirth.day

        return this.moment(dt).format('YYYY-MM-DD')
      }
      return false
    },

    dateOfDeath () {
      if (this.dtOfDeath.day && this.dtOfDeath.month && this.dtOfDeath.year) {
        const dt = this.dtOfDeath.year + '-' + this.dtOfDeath.month + '-' + this.dtOfDeath.day

        return this.moment(dt).format('YYYY-MM-DD')
      }
      return false
    },

    days () {
      const days = []

      for (let i = 1; i <= 31; i++) {
        days.push(i)
      }

      return days
    },

    showResetDateOfBirth () {
      return !!this.dtOfBirth.day || !!this.dtOfBirth.month || !!this.dtOfBirth.year
    },

    showResetDateOfDeath () {
      return !!this.dtOfDeath.day || !!this.dtOfDeath.month || !!this.dtOfDeath.year
    },

    sortedLaureateAwards () {
      const awards = this.laureate.awards
      return awards.sort((a, b) => a.pivot.year - b.pivot.year)
    },

    years () {
      const years = []

      for (var i = this.moment().add(5, 'year').format('YYYY'); i >= 1900; i--) {
        years.push(i)
      }

      return years
    }
  },

  methods: {
    addRemoveLink (index) {
      if (index) {
        this.links.splice(index, 1)
        return
      }
      this.links.push('')
    },

    callConfirmDeleteLaureateDialog () {
      this.$refs.confirmDeleteLaureateDialog.open()
        .then((confirm) => {
          if (confirm) {
            this.deleteLaureate()
          }
        })
        .catch((error) => {
          console.log(error)
          this.showErrorMessage()
        })
    },

    callConfirmUnlinkAwardDialog (item) {
      this.awardToUnlink = item

      this.$refs.confirmUnlinkAwardDialog.open()
        .then((confirm) => {
          if (confirm) {
            this.laureate.awards = this.laureate.awards.filter(el => el.id !== item.id)
          }
        })
        .catch((error) => {
          console.log(error)
          this.showErrorMessage()
        })
    },

    closeLinkAwardDialog () {
      this.linkAwardDialog = false
    },

    deleteLaureate () {
      this.$http.delete('/laureates/' + this.laureate.id)
        .then(({ data }) => {
          this.$router.push({ name: 'laureates.index' })

          this.showSuccessMessage('Laureate was deleted successfully!')
        })
        .catch(error => {
          console.log(error)
        })
    },

    getAwards () {
      return this.$http.get('/awards')
        .then(({ data }) => {
          this.awards = data.awards
        })
        .catch(error => {
          console.log(error)
        })
    },

    getCountries () {
      return this.$http.get('/countries')
        .then(({ data }) => {
          this.countries = data.countries
        })
        .catch(error => {
          console.log(error)
        })
    },

    getLaureate () {
      return this.$http.get('/laureates/' + this.$route.params.id)
        .then(({ data }) => {
          this.laureate = data.laureate

          if (this.laureate.date_of_birth) {
            this.dtOfBirth.day = parseInt(this.laureate.date_of_birth.substring(8, 10))
            this.dtOfBirth.month = parseInt(this.laureate.date_of_birth.substring(5, 7))
            this.dtOfBirth.year = parseInt(this.laureate.date_of_birth.substring(0, 4))
          }

          if (this.laureate.date_of_death) {
            this.dtOfDeath.day = parseInt(this.laureate.date_of_death.substring(8, 10))
            this.dtOfDeath.month = parseInt(this.laureate.date_of_death.substring(5, 7))
            this.dtOfDeath.year = parseInt(this.laureate.date_of_death.substring(0, 4))
          }

          this.laureate.countries = this.laureate.countries.map(item => item.id)
          this.laureate.nationalities = this.laureate.nationalities.map(item => item.id)
          this.laureate.professions = this.laureate.professions.map(item => item.id)

          this.links = JSON.parse(this.laureate.links)

          this.heroImg = this.laureate.image
        })
        .catch(error => {
          console.log(error)
        })
    },

    getProfessions () {
      return this.$http.get('/professions')
        .then(({ data }) => {
          this.professions = data.professions
        })
        .catch(error => {
          console.log(error)
        })
    },

    isNotHeroImg () {
      return !this.heroImg.match(/.(jpg|jpeg|png)$/i)
    },

    linkAward (item) {
      this.laureate.awards.push(item)

      this.linkAwardDialog = false
    },

    onFileChange (img, e) {
      const files = e.target.files || e.dataTransfer.files

      if (!files[0].name.match(/.(jpg|jpeg|png)$/i)) {
        this.showCustomErrorMessage('Ooops! You can upload jpg, jpeg, png extensions files only', 3000)
        return
      }

      if (files[0].size > 5242880) {
        this.showCustomErrorMessage('Ooops! Maximum upload file size: 5MB', 3000)
        return
      }

      if (!files.length) return

      const file = files[0]

      const reader = new FileReader()
      reader.onload = f => {
        // f.target.result contains the base64 encoding of the image
        this[img] = f.target.result
      }
      reader.readAsDataURL(file)
    },

    removeHeroImage () {
      this.heroImg = ''
    },

    resetDateOfBirth () {
      this.dtOfBirth.day = ''
      this.dtOfBirth.month = ''
      this.dtOfBirth.year = ''
    },

    resetDateOfDeath () {
      this.dtOfDeath.day = ''
      this.dtOfDeath.month = ''
      this.dtOfDeath.year = ''
    },

    save () {
      this.laureate.links = JSON.stringify(this.links)
      this.laureate.image = this.heroImg

      this.laureate.date_of_birth = this.dateOfBirth || null
      this.laureate.date_of_death = this.dateOfDeath || null

      this.laureate.publish_new = this.laureate.publish_new ? 1 : 0

      this.$http.put('/laureates/' + this.laureate.id, this.laureate)
        .then(({ data }) => {
          this.showSuccessMessage('Laureate was updated successfully!')
        })
        .catch(error => {
          console.log(error)
          this.showErrorMessage()
        })
    }
  }
}
</script>

<style scoped>
  .dropzone-hero-img {
    width: 100%;
    height: 200px;
    position: relative;
    border: 2px dashed rgba(0,0,0,0.12);
    color: rgba(0, 0, 0, 0.6);
    display: grid;
    place-items: center;
  }

  .dropzone-hero-img:hover {
    border: 2px dashed rgba(23,122,152,0.4);;
    background-color: #E8F2F4;
    cursor: pointer;
    color: #177a97;
  }

  .dropzone-hero-img img {
    display: block;
    margin: auto;
    max-height: 196px !important;
    max-width: 100% !important;
  }

  .remove-image-btn {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .list-avatar {
    width: 24px;
  }

  .list-avatar img {
    max-height: 48px;
    max-width: 48px;
    vertical-align: middle;
  }

  .links >>> .theme--light.v-icon.mdi-plus {
    color: #177a97 !important;
  }

  .links >>> .theme--light.v-icon.mdi-minus {
    color: #d81b60 !important;
  }
</style>
